import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50 whitespace-nowrap">
                樱桃视频
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              让好内容被更多人看见。樱桃视频致力于为视频爱好者提供高质量的内容推荐与深度行业分析。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              内容分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/hot" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">热门推荐</Link>
              <Link to="/category/news" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">最新资讯</Link>
              <Link to="/category/tutorial" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">观看指南</Link>
              <Link to="/category/review" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">内容评测</Link>
              <Link to="/category/tech" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">技术分享</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">关于我们</Link>
              <Link to="/about#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">联系我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              关注我们
            </h4>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-sm text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-sm text-foreground-200"></i>
              </a>
            </div>
            <p className="text-sm text-foreground-400 mt-4">
              联系邮箱：contact@cherryvideo.com
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 樱桃视频 CherryVideo. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer" rel="nofollow">Cookie 设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}